module.exports = __webpack_public_path__ + "static/img/1037.b44ad4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1037.jpg
// module id = 219
// module chunks = 0